import { render, staticRenderFns } from "./MenuMessageExclamationFilled.vue?vue&type=template&id=5d2f2748"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports